<template>
  <div class="product-tabPaneConrtent ">
    <div v-if="dataList && dataList.length > 0" class="product-tabPaneConrtent-content ">
      <Card v-for="item in dataList" :key="item.id" :item="item" @viewDetails="viewDetails" />
    </div>
    <div v-if="dataList && dataList.length > 0" class="product-tabPaneConrtent-content-mobile ">
      <CardMobile v-for="item in dataList" :key="item.id" :item="item" @viewDetails="viewDetails" />
    </div>
    <div v-if="dataList && dataList.length === 0" class="product-tabPaneConrtent-content-no">
      暂无数据
    </div>
    <div style="margin-bottom: 50px;margin-top: 30px;">
      <a-pagination v-model:current="pagination.current" v-model:page-size="pagination.pageSize" :total="list.length"
        :show-total="total => `共 ${total} 条`" :pageSizeOptions="['12', '24', '36', '48', '60']" show-size-changer
        show-quick-jumper :showQuickJumper="true" />
    </div>

  </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'
import Card from "./card.vue"
import CardMobile from "./cardMobile.vue"


const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  }
})
const emit = defineEmits(['viewDetails'])

const pagination = reactive({
  current: 1,
  pageSize: 12
})

const pageSizeOptions = ref()

const list = computed(() => {
  let _list = []
  if (props.data?.associationFieldsb2d1b102) {
    _list = props.data.associationFieldsb2d1b102
  }
  _list.sort(function (a, b) {
    return b.number68b2284b - a.number68b2284b;
  });

  return _list
})

const dataList = computed(() => {
  return list.value.slice((pagination.current - 1) * pagination.pageSize, pagination.current * pagination.pageSize)
})

const viewDetails = (data) => {
  emit('viewDetails', data, list.value)
}

</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
  .product-tabPaneConrtent {
    padding: 0 2% 0 2% !important;
  }

  .product-tabPaneConrtent-content {
    display: none !important;
  }

  .product-tabPaneConrtent-content-mobile {
    display: flex !important;
  }
}



@media screen and (min-width: 800px) {
  .product-tabPaneConrtent {
    padding: 0 19% 0 18% !important;
  }

  .product-tabPaneConrtent-content {
    display: grid !important;
  }

  .product-tabPaneConrtent-content-mobile {
    display: none !important;
  }
}

.product-tabPaneConrtent {
  width: 100%;
  padding: 0 19% 0 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-tabPaneConrtent-content-mobile {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-tabPaneConrtent-content {
  width: 100%;
  height: 100%;
  min-height: 323px;
  // display: flex;
  // flex-wrap: wrap;
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 240px);
  grid-gap: 10px;
  margin-top: 20px;
  // justify-content: space-evenly;
}

.product-tabPaneConrtent-content-no {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-family: 'PuHuiTiRegular';
  min-height: 323px;
}
</style>